import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import { SelectItem } from '../../shared';

@Component({
    selector: 'ef-burden-filters-presenter',
    templateUrl: './burden-filters-presenter.component.html',
    styleUrls: ['./burden-filters-presenter.component.scss'],
    standalone: false
})
export class BurdenFiltersPresenterComponent implements OnInit, OnDestroy {
    @Input() contracts: SelectItem[];
    @Output() SelectContract = new EventEmitter<string>();
    @Output() ToggleDetails = new EventEmitter<boolean>();
    private active = true;

    filterFormGroup: UntypedFormGroup;
    constructor() {
        this.filterFormGroup = new UntypedFormGroup({
            Contracts: new UntypedFormControl(null)
        });
    }

    ngOnInit(): void {
        this.filterFormGroup.controls['Contracts'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => this.SelectContract.next(value));
    }
    ngOnDestroy(): void {
        this.active = false;
    }
}
